import { InputBase, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

import { PlannerTag, PlannerTagVariant } from "../PlannerTag"
import { cellFieldMissingStyle, cellFieldStyle } from "./cellFieldStyles"

const useStyles = makeStyles()((theme) => ({
    input: {
        ...cellFieldStyle(theme),
        width: "2.75rem",
        padding: "0 .125rem 0 .25rem",
        color: theme.palette.tailwind.slate[800],
        fontWeight: 700,
        fontSize: ".75rem",
        "& input": {
            padding: ".125rem 0",
        },
        "& input::placeholder": {
            color: theme.palette.tailwind.slate[600],
            opacity: 1,
        },
    },
    inputError: cellFieldMissingStyle(theme),
    currency: {
        color: theme.palette.tailwind.slate[600],
        fontWeight: 700,
    },
}))

type Props = Readonly<{
    value: string
    hasError: boolean
    isLocked: boolean
    isSameAllWeek: boolean
    onChange: (value: string) => void
}>

export function CellPriceField({ value, hasError, isLocked, isSameAllWeek, onChange }: Props) {
    const { classes, cx } = useStyles()

    if (isLocked) {
        return isSameAllWeek ? (
            <PlannerTag variant={PlannerTagVariant.GLOBAL}>
                <LocalizedStrict id="merchant-week-menu-cell-price-locked-all-week" vars={{ price: value }}>
                    <span>{value} DKK · all week</span>
                </LocalizedStrict>
            </PlannerTag>
        ) : (
            <PlannerTag variant={PlannerTagVariant.GLOBAL}>
                <LocalizedStrict id="merchant-week-menu-cell-price-locked" vars={{ price: value }}>
                    <span>{value} DKK</span>
                </LocalizedStrict>
            </PlannerTag>
        )
    }

    return (
        <Stack direction="row" alignItems="center" spacing=".25rem">
            <LocalizedStrict id="merchant-week-menu-cell-price-field" attrs={{ placeholder: true }}>
                <InputBase
                    value={value}
                    placeholder="0"
                    className={cx(classes.input, hasError && classes.inputError)}
                    onChange={(event) => onChange(event.target.value.replace(/[^0-9.,]/g, ""))}
                />
            </LocalizedStrict>
            <LocalizedStrict id="merchant-week-menu-currency-label">
                <Typography variant="caption" className={classes.currency}>
                    DKK
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
